import { DetalleCesionRequest } from "./DetalleCesionRequest";

export class CesionRequest {
   emisorId: string;
   dteId: string;
   personaAutorizadaCesionId: string;
   rutPersonaAutorizada: number;
   dvPersonaAutorizada: string;
   nombrePersonaAutorizada: string;
   correoPersonaAutorizada: string;
   fechaEmision: Date;
   fechaVencimiento: Date;
   rutEmisor: number;
   codigoTipoDte: number;
   folio: number;
   montoTotal: number;
   detalleCesions: DetalleCesionRequest[];
}
